export default {
  'base': {
    'Add': 'create',
    'add': 'add',
    'delete': 'delete',
    'edit': 'edit',
    'update': 'update',
    'start': 'enable',
    'stop': 'disable',
    'lock': 'locked',
    'hasDelete': 'deleted',
    'create': 'create',
    'modify': 'modify',
    'cancel': 'cancel',
    'sure': 'confirm',
    'search': 'Please enter keywords',
    'select': 'Please select a drop-down option',
    'import': 'Batch import',
    'importT': 'Batch import: ',
    'export': 'Batch export',
    'yes': 'yes',
    'no': 'no',
    'return': 'return',
    'save': 'save',
    'PleaseInputAValidPhoneNumber': 'Please input a valid phone number',
    'PleaseInputAValidEmail': 'Please input a valid email address',
    'PleaseEnterChinese': 'Please enter Chinese',
    'PleaseEnterEnglish': 'Please enter English',
    'PleaseEnterEnglishOrNumbers': 'Please enter English or numbers',
    'importSuccess': 'Import successfully',
    'OnlyCanInputLettersNumbersOrPoint': 'You can only enter letters, numbers, "." or "_", start with letters and cannot end up with ".". "." can not be continuous. ',
    'OnlyCanInputZhEnOrSign': 'Can only enter Chinese, English, line-through and half-width brackets',
    'OnlyCanInputEnOrSign': 'Can only enter English, line-through and half-width brackets',
    'OnlyCanInputEnOrSpace': 'Can only enter English, numbers and special characters (include space)',
    'OnlyCanInputChineseOrLetters': 'You can only enter Chinese or English',
    'toClose': 'Confirm closing? All entered content will be lost after closing.',
    'confirmToClose': 'Confirm closing',
    'UnknownError': 'Unknown error. Please try again later.',
    'FileTypeError': 'File type error',
    'FileSizeTooLarge': 'File size cannot exceed 1MB',
    'PleaseChooseOrg': 'Please select an organization',
    'PleaseSelect': 'Please select',
    'createdAt': 'creation time',
    'updatedAt': 'update time',
    'Operation': 'operation',
    'AreYouSureToDelete': 'Are you sure to delete {name} ? {moduleName} will not be recovered after confirming.',
    'noData': 'No data',
    'tip': 'tip',
    'date': 'day',
    'hour': 'hour',
    'startTime': 'start date',
    'ensTime': 'end date',
    'min': 'minute',
    'space': '',
    'numberTip': 'Please enter the correct landline or mobile number'
  },
  'common': {
    'province': 'province',
    'city': 'city',
    'region': 'region',
    'form': {
      'notNum': 'You can only enter letters or ".", and cannot end up with "."'
    }
  },
  'sidebar': {
    'orgManage': 'Organization management',
    'orgList': 'Organization list',
    'addOrg': 'Add an organization',
    'detailOrg': 'Organization details',
    'editOrg': 'Edit the organization',
    'editDepartment': 'Edit the department',
    'addDepartment': 'Add a department',
    'detailDepartment': 'Department details',
    'privilegeManage': 'Authority management',
    'privilegeList': 'Authority list',
    'detailPrivilege': 'Authority management details',
    'menuManage': 'Menu management',
    'menuList': 'Menu list',
    'detailMenu': 'Menu details',
    'districtManage': 'Administrative division management',
    'districtList': 'Administrative division list',
    'detailDistrict': 'Administrative division details',
    'editDistrict': 'Edit the administrative division',
    'saleManage': 'Sales division management',
    'saleList': 'Sales division list',
    'detailSale': 'Sales division details',
    'editSale': 'Edit the sales division',
    'thirdPartManage': 'Third party access management',
    'thirdPartList': 'Third party access list',
    'Dashboard': 'Workbench',
    'UserMng': 'User management',
    'UserList': 'User list',
    'District': 'Administrative division',
    'RoleMng': 'Role management',
    'RoleList': 'Role list',
    'RoleDetails': 'Role list',
    'RoleAdd': 'Add role',
    'RoleEdit': 'Edit role',
    'PostMng': 'Post management',
    'PostList': 'Post list',
    'AppMng': 'Application management',
    'AppList': 'Application list',
    'AppAdd': 'Add application',
    'AppEdit': 'Edit application',
    'editPosition': 'Edit post',
    'detailPosition': 'Post details',
    'UserInfo': 'Account information',
    'InfoMng': 'Information management',
    'BaseInfo': 'Basic information',
    'SetPwd': 'Modify password',
    'SetPhone': 'Modify phone number',
    'SetEmail': 'Modify email address',
    'ReportExport': 'Report export',
    'Log': 'Log management',
    'LogList': 'Log list',
    'ReportLine': 'Organization reporting line',
    'creditDevice': 'Authorized device',
    'creditDeviceList': 'Authorized device list',
    'creditDeviceAudit': 'Authorized device audit',
    'shortMsgConf': 'SMS configuration',
    'UserMng2C': 'C-end user management',
    'StaffMng': 'Staff management'
  },
  'Navbar': {
    'Home': 'Home',
    'UserInfo': 'Account Information',
    'LogOut': 'Log Out',
    'AppSwitch': 'Application Switch'
  },
  'lang': {
    'zh': 'Simplified Chinese',
    'en': 'English'
  },
  'org': {
    'AllOrg': 'All organizations',
    'Org': 'Organization',
    'Dep': 'Department',
    'insList': 'Organization list',
    'depList': 'Department list',
    'PleaseInputOrgName': 'Please enter the organization name',
    'PleaseInputOrgCode': 'Please enter the organization code',
    'table': {
      'yeePayId': 'yeePayId',
      'insAllName': 'organization full name',
      'insName': 'organization name',
      'insCode': 'organization code',
      'insStatus': 'organization status',
      'insDes': 'organization description',
      'depName': 'department name',
      'supName': 'superior name',
      'depStatus': 'department status',
      'depDes': 'department description'
    },
    'manage': 'Organization management',
    'name': 'Organization: ',
    'add': 'Add an organization',
    'editOrg': 'Edit the organization',
    'resetPwd': 'Reset password',
    'PleaseSelect': 'Please select',
    'Organization': 'Organization',
    'Select': 'Select',
    'ChosenInstitution': 'Selected organization',
    'Unselect': 'Cancel selection',
    'chooseRole': 'Select a role',
    'PleaseInputPwd': 'Please enter the password',
    'PleaseInputTheCorrectPassword': 'Please enter a valid-formatted password',
    'PwdDesc': 'The password is 10 to 16 characters in length and contains at least three types out of the four: uppercase letters, lowercase letters, numbers or special characters (only including `~!@#$%^&*()_-).',
    'pleaseChooseOrg': 'Please select an organization',
    'PleaseSelectRoles': 'Please select a role',
    'SuccessfullyResetPwd': 'Reset organization password successfully',
    'edit': 'Edit organization',
    'addDepart': 'Add department',
    'editDepart': 'Edit department',
    'detailDepart': 'Department details',
    'detailPosition': 'Post details',
    'editPosition': 'Edit the post',
    'search': 'Please enter keywords',
    'PleaseInputInstitutionName': 'Please enter organization name or code',
    'select': 'Please select a drop-down option',
    'detail': 'Organization details',
    'import': 'Batch import',
    'importT': 'Batch import: ',
    'browse': 'Browse',
    'upload': 'Upload',
    'importInfo': 'Import directions: ',
    'importDes': '1. Fill out file in the template; 2. Upload the completed file; 3. Import the uploaded file',
    'clickThis': 'Click here',
    'importTem': 'Download uploaded template',
    'export': 'Batch export',
    'toClose': 'Confirm closing?',
    'deleteOrgInfo': 'Delete the organization. It cannot be recovered after deleting. Confirm deleting?',
    'deleteDepartInfo': 'Delete the department. It cannot be recovered after deleting. Confirm deleting?',
    'deletePostInfo': 'Delete the post. It cannot be recovered after deleting. Confirm deleting?',
    'tip': 'tip',
    'form': {
      'PleaseAtLeastSelectCity': 'Please select a city at least',
      'managerMobile': 'General manager: ',
      'pleaseInputManagerMobile': 'Please enter the phone number of general manager',
      'adminMobile': 'Dealer admin: ',
      'pleaseInputAdminMobile': 'Please enter the phone number of dealer admin',
      'pleaseInputSalesHotline': 'Please enter the phone number of sales',
      'pleaseInputServiceHotline': 'Please enter the phone number of service',
      'type': 'Node type: ',
      'full': 'Full name of the organization: ',
      'dFull': 'Department name: ',
      'parent': 'Superior department: ',
      'dStatus': 'Department status: ',
      'num': 'Number of department staff: ',
      'dArea': 'Located area: ',
      'dContacts': 'Department contacts: ',
      'dDescription': 'Department description: ',
      'status': 'Organization status: ',
      'division': 'Administrative division: ',
      'code': 'Organization code: ',
      'address': 'Address information: ',
      'tel': 'Phone number: ',
      'manager': 'Organization admin: ',
      'contacts': 'Organization contacts: ',
      'create': 'Creation time: ',
      'start': 'Enable time: ',
      'update': 'Update time: ',
      'description': 'Department description: ',
      'orgDescription': 'Organization description: ',
      'placeholder': 'Please select a node type',
      'chooseStatus': 'Please select a status',
      'nodeError': 'Failed to get node type list',
      'statusError': 'Failed to get organization status list',
      'addSuccess': 'Add successfully',
      'addError': 'Failed to add',
      'uploadSuccess': 'Upload successfully',
      'uploadError': 'Failed to upload',
      'modifySuccess': 'Modify successfully',
      'modifyError': 'Failed to modify',
      'deleteSuccess': 'Delete successfully',
      'deleteError': 'Failed to delete',
      'deleteCancel': 'Cancel deletion',
      'errorInfo': 'Cannot be null',
      'adDivision': 'Administrative division: ',
      'errorReg': 'Incorrect format',
      'position': 'Post name: ',
      'alias': 'Alias: ',
      'belongDepart': 'Department: ',
      'demand': 'Job requirements: ',
      'limit': 'Post limitations: ',
      'positionDes': 'Post description: ',
      'need': 'Need interview?',
      'training': 'Need training?',
      'partTime': 'Is it possible to work part-time?',
      'manage': 'Is it a managerial post?',
      'depart': 'Department',
      'post': 'Post',
      'person': 'Person',
      'postStatus': 'Post status: ',
      'entityCode': 'Entity code: ',
      'serviceCode': 'After sales code: ',
      'businessNo': 'Sub-store number: ',
      'serviceArea': 'Service scope: ',
      'pleaseSelectServiceArea': 'Please select service scope',
      'uploadImg': 'Upload picture: ',
      'uploadVideo': 'Upload video: ',
      'departType': 'Department categories: ',
      'salesHotline': 'Sales Hotline: ',
      'serviceHotline': 'Service Hotline: ',
      'longitude': 'longitude',
      'latitude': 'latitude',
      'longitudeTip': 'Please enter the correct longitude',
      'latitudeTip': 'Please enter the correct latitude',
      'addressTip': 'No valid latitude and longitude information was found for this address'
    }
  },
  'privilege': {
    'privilegeList': 'Authority list',
    'manage': 'Authority management',
    'name': 'Authority name',
    'code': 'Authority code',
    'description': 'Authority description',
    'updateAt': 'Modification time',
    'belongApp': 'Application',
    'PleaseChooseApp': 'Please select the application',
    'firstLevelPrivilege': 'Primary level authority',
    'PleaseChooseFirstLevelPrivilege': 'Please select the primary level authority',
    'secondLevelPrivilege': 'Secondary level authority',
    'PleaseChooseSecondLevelPrivilege': 'Please select the secondary level authority',
    'addPrivilege': 'Add an authority',
    'detail': 'Authority details',
    'edit': 'Edit the authority',
    'form': {
      'privilegeName': 'Authority name: ',
      'code': 'Authority code: ',
      'description': 'Authority description: ',
      'create': 'Creation time: ',
      'modify': 'Modification time: ',
      'deletePriInfo': 'Delete the authority. The authority cannot be recovered after deleting. Confirm deleting?'
    }
  },
  'menu': {
    'Menu': 'Menu',
    'name': 'Name',
    'category': 'Type',
    'url': 'Link address',
    'relatedPri': 'Associated authority',
    'detail': 'Menu details',
    'manage': 'Menu management',
    'belongApp': 'Application',
    'PleaseChooseApp': 'Please select the application',
    'firstLevelMenu': 'Primary level menu',
    'thirdLevelMenu': 'Third level menu',
    'fourthLevelMenu': 'Fourth level menu',
    'PleaseChooseFirstLevelMenu': 'Please select the primary level menu',
    'PleaseChooseThirdLevelMenu': 'Please select the third level menu',
    'PleaseChooseFourthLevelMenu': 'Please select the fourth level menu',
    'secondLevelMenu': 'Secondary level menu',
    'PleaseChooseSecondLevelMenu': 'Please select the secondary level menu',
    'menuList': 'Menu list',
    'addMenu': 'Add a primary level menu',
    'edit': 'Edit the menu',
    'del': 'Confirm to delete the menu? The menu cannot be recovered once confirmed.',
    'nullData': 'Obtained data is null',
    'form': {
      'name': 'Menu name: ',
      'displayCN': 'Chinese display name of menu: ',
      'displayEN': 'English display name of menu: ',
      'link': 'Menu link address: ',
      'isVirtual': 'Is it a virtual menu: ',
      'isAlert': 'Is it a popup: ',
      'category': 'Menu category: ',
      'description': 'Description: ',
      'relatedPri': 'Associated authority: ',
      'create': 'Creation time: ',
      'modify': 'Modification time: ',
      'btnName': 'Button name: ',
      'pageId': 'Menu code: ',
      'resourceId': 'Button code: ',
      'btnCategory': 'Button category: ',
      'btnDes': 'Button description: ',
      'addCategory': 'Add a category: ',
      'domain': 'Domain name of menu link: ',
      'btnDomain': 'Domain name of button link: ',
      'path': 'Path of menu link: ',
      'addMenu': 'Add a menu',
      'btnCN': 'Chinese display name of button: ',
      'btnEN': 'English display name of button: ',
      'priority': 'Sorting weight',
      'isShow': 'Whether to show'
    }
  },
  'district': {
    'District': 'Administrative division',
    'country': 'Country',
    'province': 'Province',
    'city': 'City',
    'PleaseSelectCountry': 'Please select a country',
    'PleaseSelectProvince': 'Please select a province',
    'PleaseSelectCity': 'Please select a city',
    'detail': 'Administrative division details',
    'full': 'Full name of the division',
    'short': 'Division abbreviation',
    'code': 'Division code',
    'cityLevel': 'City classification',
    'parentName': 'Name of superior administrative division',
    'parentCode': 'Code of superior administrative division',
    'list': 'Administrative division list',
    'edit': 'Edit the administrative division',
    'add': 'Add an administrative division',
    'delete': 'Delete the administrative division',
    'tip': 'Confirm to delete the node? The node and its sub-nodes cannot be recovered once confirmed.',
    'form': {
      'name': 'Division name: ',
      'short': 'Division abbreviation: ',
      'code': 'Division code: ',
      'full': 'Full name: ',
      'city': 'City classification: ',
      'parentDistrict': 'Name of superior administrative division: ',
      'parentCode': 'Code of superior administrative division: ',
      'outdate': 'Is it expired: ',
      'expiredPlace': 'Please select whether it is expired',
      'hasExpired': 'Expired',
      'notExpired': 'Unexpired',
      'cityPlace': 'Please select the city level'
    }
  },
  'sale': {
    'Sale': 'Sales division',
    'firstLevel': 'Primary level division',
    'secondLevel': 'Secondary level division',
    'thirdLevel': 'Tertiary level devision',
    'PleaseSelectFirstLevel': 'Please select a primary level division',
    'PleaseSelectSecondLevel': 'Please select a secondary level division',
    'PleaseSelectThirdLevel': 'Please select a teriary level division',
    'detail': 'Sales division details',
    'list': 'Sales division list',
    'info': 'Division information',
    'delete': 'Delete the sales division',
    'edit': 'Edit the sales division',
    'tip': 'Confirm to delete the node? The node and its sub-nodes cannot be recovered once confirmed.',
    'parent': 'Superior division',
    'form': {
      'name': 'Division name',
      'code': 'Division code',
      'description': 'Division description',
      'region': 'Scope of jurisdiction',
      'parentName': 'Name of superior division',
      'parentSale': 'Code of superior division',
      'addSale': 'Add a sales division'
    }
  },
  'user': {
    'User': 'User',
    'Position': 'Post',
    'pleaseChooseOrg': 'Please select an organization',
    'UserMng': 'User management',
    'Dealer': 'Dealer',
    'OEM': 'OEM',
    'PleaseSelect': 'Please select',
    'PleaseInputInstitutionName': 'Please enter organization name or code',
    'Select': 'Select',
    'ChosenInstitution': 'Selected organization',
    'Unselect': 'Cancel selection',
    'ExportInstructions': 'Export directions',
    'ExportUpTo60': 'Export data of 60 organizations once at most',
    'IfChooseNoneExportAll': 'If no selection, export all users by default',
    'Organization': 'Organization',
    'UserList': 'User list',
    'Export': 'Export',
    'Import': 'Import',
    'BatchExport': 'Batch export',
    'BatchImport': 'Batch import',
    'ShowDetails': 'See details',
    'Start': 'Enable',
    'Stop': 'Disable',
    'Edit': 'Edit',
    'Delete': 'Delete',
    'BatchStart': 'Batch enable',
    'BatchStop': 'Batch disable',
    'BatchDelete': 'Batch delete',
    'AssociateRoles': 'Associated role',
    'BrowseFile': 'Browse',
    'Upload': 'Upload',
    'ImportInstructions': 'Import directions',
    'ClickHere': 'Click here',
    'DownloadImportTemplateFile': 'Download imported template file',
    'FillImportFile': 'Fill out file in the template',
    'ChooseFile': 'Upload completed file',
    'UploadFile': 'Import the uploaded file',
    'UserInfo': 'User information',
    'Name': 'Name',
    'InOrganization': 'Organization',
    'Manager': 'Administrator',
    'ManagerDep': 'Administrator organization',
    'EmpNo': 'Employee number',
    'HotEmpNo': 'Hotline agent number',
    'Cellphone': 'phone number',
    'Email': 'Email',
    'DepPost': 'Department post table',
    'DirectSuperiors': 'Direct superiors',
    'Post': 'Post',
    'manageInstitution': 'Manage entire store',
    'UserRoles': 'User role table',
    'EditUser': 'Edit the user',
    'AddUser': 'Add a user',
    'DataCollision': 'Data collision',
    'UserAlreadyExists': 'The user already exists. Do you need to associate the two?',
    'SuccessfullyAdded': 'Add successfully',
    'MustInputCellphoneOrEmail': 'Fill in at least one of your phone or email',
    'PleaseFillInCellphoneNumberOrEmail': 'Please enter phone or email',
    'PleaseSelectPost': 'Please select a post',
    'PleaseSelectSuperiorPost': 'Please select direct superior post',
    'SuccessfullyUpdated': 'Update successfully',
    'SuccessfullyDeleted': 'Delete successfully',
    'DeleteUser': 'Delete the user',
    'selectedUsers': 'Selected user',
    'AreYouSureToStartOrStopThisUser': 'Confirm to {operation} {name} ?',
    'SuccessfullyStarted': 'Enable successfully',
    'SuccessfullyStoped': 'Disable successfully',
    'SuccessfullyAssociated': 'Associate successfully',
    'DisplayName': 'User name',
    'PleaseInputUserName': 'Please enter a username',
    'PleaseInputCellphoneNumber': 'Please enter a phone number',
    'PleaseInputDisplayName': 'Please enter a name',
    'PleaseInputEmpNo': 'Please enter an employee number',
    'PleaseInputHotEmpNo': 'Please enter a hotline agent number',
    'PleaseInputEmail': 'Please enter a email address',
    'PleaseInputPostName': 'Please enter the post name',
    'Operation': 'Operation',
    'Phone': 'User phone',
    'Department': 'Department',
    'SuccessfullyImported': 'Import successfully',
    'ResetPwd': 'Reset password',
    'InitialPwd': 'Initialize password',
    'PleaseInputTheCorrectPassword': 'Please enter a valid-formatted password',
    'PwdDesc': 'The password is 10 to 16 characters in length and contains at least three types out of the four: uppercase letters, lowercase letters, number or special characters (only including `~!@#$%^&*()_-)',
    'SuccessfullyResetPwd': 'Reset password successfully',
    'randomPwd': 'Random password',
    'userDefined': 'Self-define password',
    'PleaseInputPwd': 'Please enter a password',
    'PleaseInputResetPwd': 'Please enter a new password',
    'reportTo': 'Reporting object',
    'DtPermissionRange': 'Data authority scope',
    'PleaseSelectReportTo': 'Please select a reporting object',
    'PleaseSelectPermissionRange': 'Please select the data authority scope',
    'orgReportLine': 'View of reporting line',
    'Account': 'Account',
    'Audit': 'Approver',
    'SuperPwd': 'Super password',
    'Open': 'Open',
    'Close': 'Close',
    'confirmToOpenPwd': 'Confirm to open {name} super password login? The operation might affect user login.',
    'PleaseInputAccount': 'Please enter the account',
    'PleaseSelectDepart': 'Please select the depart',
    'PleaseSelectOneDepart': 'Please select at least 1 depart',
    'PleaseSelectDepartType': 'Please select the depart category',
    'loginAuthentication': 'Login authentication',
    'UploadAvatarOnlyDealer': 'Upload portrait (only sales post)',
    'Avatar': 'Picture:',
    'Video': 'Video:',
    'uploadTypeTip': 'Only support those formats of uploaded file: ',
    'uploadSizeTip': 'Size of uploaded file cannot exceeds',
    'uploadLimitTip': 'Current limit selects {limit} files',
    'uploading': 'Uploading',
    'Depart': 'Depart',
    'MngPost': 'Manage Post'
  },
  'searchPanel': {
    'StartDate': 'Start time',
    'EndDate': 'End time',
    'Search': 'Search',
    'Reset': 'Reset',
    'PleaseInput': 'Please enter',
    'PleaseSelect': 'Please select'
  },
  'role': {
    'RoleTags': 'Associated tags',
    'PleaseSelectTags': 'Please select tags',
    'RoleList': 'Role list',
    'Role': 'Role',
    'App': 'Application',
    'RoleName': 'Role name',
    'PleaseChooseApp': 'Please select the application',
    'PleaseInputRoleName': 'Please enter the role name',
    'AddRole': 'Add a role',
    'RoleDescription': 'Role description',
    'Category': 'Category',
    'Automaker': 'OEM',
    'Dealer': 'Dealer',
    'Designer': 'Designer',
    'Supplier': 'Supplier',
    'Client': 'Customer',
    'BatchDelete': 'Batch delete',
    'DeleteRole': 'Delete the role',
    'SelectedRole': 'Selected role',
    'AreYouSureToDelete': 'Do you confirm to delete',
    'RoleMng': 'Role management',
    'Back': 'Return',
    'MenuInfo': 'Menu information',
    'ButtonInfo': 'Button information',
    'Department': 'Department',
    'RoleCode': 'Role code',
    'RoleType': 'Role type',
    'MenuAuthority': 'Menu authority tree',
    'MenuName': 'Menu name',
    'ButtonName': 'Button name',
    'MenuUrl': 'Menu link address',
    'ButtonPageID': 'Menu code',
    'ButtonResourceID': 'Button code',
    'Description': 'Description',
    'ButtonDescription': 'Button description',
    'Authority': 'Associated authority',
    'CreatedTime': 'Creation time',
    'ModifiedTime': 'Modification time',
    'RelatedUser': 'Role-associated user',
    'BaseInfo': 'Basic information',
    'Save': 'Save',
    'RoleCategory': 'Role category',
    'PleaseInputName': 'Please enter the role name',
    'PleaseChooseCategory': 'Please enter the role category',
    'PleaseInputRoleCode': 'Please enter the role code',
    'PleaseInputRoleDesc': 'Please enter the role description',
    'TheFormatIsIncorrect': 'You can only enter letters or ".", and cannot start or end up with "."',
    'SuccessfullyCreated': 'Create successfully',
    'SuccessfullyUpdated': 'Modify successfully',
    'SuccessfullyImported': 'Import successfully',
    'updateConfirm': 'Modifying role information has a great impact. Please confirm whether to modify it?'
  },
  'app': {
    'app': 'Application',
    'AppList': 'Application list',
    'AddApp': 'Add an application',
    'Keyword': 'Keywords',
    'PleaseInputAppName': 'Please enter application name',
    'AppName': 'Application name',
    'PleaseInputAppEnName': 'Please enter application english name',
    'AppEnName': 'Application english name',
    'AppCode': 'Application code',
    'AppUrl': 'Application link',
    'DeleteApp': 'Delete application',
    'Url': 'Link address',
    'AppIcon': 'Application icon',
    'AppIntro': 'Application description',
    'OpenInNewWindow': 'Open in a new window',
    'PleaseInputCode': 'Please enter application code',
    'PleaseInputName': 'Please enter application name',
    'PleaseInputUrl': 'Please enter link address',
    'PleaseInputAppIntro': 'Please enter application description',
    'TheIconIsMissing': 'Unable to get the application icon data',
    'AppId': 'AppId',
    'supportDimission': 'Support dimission',
    'equipmentValidation': 'Device verification',
    'details': 'Application details',
    'expired': 'Access expired',
    'autoAudit': 'Automatic device audit',
    'TimeGreaterThan0': 'Time must be greater than 0',
    'shortMsgConf': 'SMS configuration',
    'GetCaptchaByPhoneNo': 'Get verification code by phone number',
    'AdminResetPwd': 'Admin resets user password',
    'Pwd7daysRemind': 'Remind daily since 7 days before password expiration',
    'PwdExpiredRemind': 'Remind after password expired',
    'PwdSuccessfullyChange': 'Remind after password was modified successfully',
    'PleaseInputShortMsgSignature': 'Please enter SMS signature',
    'PleaseInputTemplateCode': 'Please enter SMS template code',
    'SignatureAndTemplateCodeCanNotOnlyInputOne': 'Please enter both SMS signature and template code',
    'SuccessfullyChangeConfig': 'SMS template is configured successfully',
    'PleaseInputAccessEffectiveDuration': 'Please enter access expiration time',
    'HourMustLessThan24': 'The number of hour must be a decimal from 0 to 24 (excluding 24)',
    'DateMustBeIntAndLessThan99': 'The number of days must be a positive integer between 0 and 99'
  },
  'thirdPart': {
    'thirdAccess': 'Third party access',
    'thisUser': 'Accessing party',
    'AccessDetails': 'Accessing party details',
    'list': 'Third party access list',
    'user': 'Accessing party',
    'client': 'client_id',
    'create': 'Creation time',
    'start': 'Start date',
    'end': 'End date',
    'no': 'number',
    'createTime': 'Creation time',
    'access': 'Accessing party',
    'clientId': 'CLIENT_ID',
    'secret': 'CLIENT_SECRET',
    'logout': 'Log out and callback',
    'introduction': 'Introduction',
    'operation': 'Operation',
    'add': 'Add an accessing party',
    'edit': 'Edit the accessing party',
    'delete': 'Delete the accessing party',
    'del': 'Confirm to delete the accessing party?',
    'PleaseInputLogout': 'Please enter logout and callback'
  },
  'userInfo': {
    'accountRule': 'Account length cannot exceed 30 digits. Account can include numbers, Chinese or English characters and special characters',
    'pwdDesc': 'The password is 10 to 16 characters in length and contains at least three types out of the four: uppercase letters, lowercase letters, number or special characters (only including `~!@#$%^&*()_-)',
    'PleaseImproveYourPersonalInformation': 'Please complete personal information',
    'UserInfo': 'User information',
    'AccountInfo': 'Account information',
    'BaseInfo': 'Basic information',
    'SetPwd': 'Modify password',
    'SetPhone': 'Modify phone number',
    'SetEmail': 'Modify email address',
    'Name': 'Name',
    'QQ': 'QQ',
    'Wechat': 'WeChat',
    'Mobile': 'Phone',
    'Email': 'Email',
    'PleaseInputName': 'Please enter the name',
    'SuccessfullyUpdated': 'Modify successfully',
    'EmployeeNo': 'Employee number',
    'Account': 'Account',
    'Institution': 'Organization',
    'Department': 'Department',
    'Post': 'Post',
    'PleaseInputAccount': 'Please enter the account',
    'PleaseInputTheCorrectAccount': 'Please enter a valid-formatted account',
    'CannotBeLongerThan20Characters': 'Cannot exceed 20 characters',
    'CannotBeLongerThan30Characters': 'Cannot exceed 30 characters',
    'OldPwd': 'Old password',
    'NewPwd': 'New password',
    'InputNewPwdAgain': 'Enter a new password again',
    'ChangePwd': 'Modify password',
    'PleaseInputOldPwd': 'Please enter the old password',
    'PleaseInputNewPwd': 'Please enter a new password',
    'PleaseInputNewPwdAgain': 'Please enter the new password',
    'PleaseInputTheCorrectPassword': 'Please enter a valid-formatted password',
    'ThePasswordsEnteredTwiceAreNotTheSame': 'Passwords entered twice are inconsistent',
    'changePwdSuccessfully': 'Modify password successfully',
    'mobileNo': 'Phone number',
    'VerifyCode': 'Verification code',
    'ChangePhoneNumber': 'Change phone number',
    'Sure': 'Confirm',
    'PleaseInputVerificationCode': 'Please enter verification code',
    'VerificationCode': 'Verification code',
    'GetVerificationCode': 'Get verification code',
    'GetVerificationCodeAfter': 'Get verification code again after {countdown} seconds',
    'MobileVerifiedSuccessfully': 'Verify phone successfully',
    'PleaseInputCellphoneNo': 'Please enter the phone number',
    'ChangeMobile': 'Modify phone number',
    'SuccessfullyChangeCellphoneNo': 'Modify phone number successfull',
    'PleaseInputEmailAddr': 'Please enter the email address',
    'ChangeEmail': 'Modify email address',
    'EmailVerifiedSuccessfully': 'Verify email successfully',
    'SuccessfullyChangeEmail': 'Modify email successfully',
    'VerificationCodeSentSuccessfully': 'Verification code has been sent to {mobileEmail} successfully',
    'ReportTo': 'Reporting object',
    'Audit': 'Approver',
    'DtRange': 'Data authority'
  },
  'operation': {
    'addSuccess': 'Add successfully!',
    'delSuccess': 'Delete successfully!',
    'editSuccess': 'Edit successfully!'
  },
  'post': {
    'PostTags': 'Associated tags',
    'PleaseSelectTags': 'Please select tags',
    'PostList': 'Post list',
    'Post': 'Post',
    'BatchExport': 'Batch export',
    'BatchImport': 'Batch import',
    'Import': 'Import',
    'BrowseFile': 'Browse',
    'Upload': 'Upload',
    'ImportInstructions': 'Import directions',
    'ClickHere': 'Click here',
    'DownloadImportTemplateFile': 'Download imported template file',
    'FillImportFile': 'Fill out file in the template',
    'ChooseFile': 'Upload the completed file',
    'UploadFile': 'Import the uploaded file',
    'FileTypeError': 'File type error',
    'AddPost': 'Add a post',
    'PleaseInputPostName': 'Please enter post name',
    'PleaseSelect': 'Please select',
    'Level': 'Level',
    'PostName': 'Post name',
    'PostLevel': 'Post level',
    'DirectSuperiors': 'Direct superiors',
    'IsOperations': 'Is it an operational post',
    'IsManager': 'Is it a managerial post',
    'CreatedTime': 'Creation time',
    'PostDes': 'Post description',
    'Operation': 'Operation',
    'PleaseSelectPostLevel': 'Please select the post level',
    'PleaseInputPostDescription': 'Please enter post description',
    'UpdatePostSuccessfully': 'Update post successfully',
    'CreatePostSuccessfully': 'Create post successfully',
    'BatchDelete': 'Batch delete',
    'DeletePost': 'Delete the post',
    'AreYouSureToDelete': 'Do you confirm to delete',
    'SelectedPost': 'Selected posts',
    'SuccessfullyDeleted': 'Delete successfully',
    'EditPost': 'Edit post',
    'PostDetails': 'Post details'
  },
  'reportExport': {
    'reportDataExport': 'Detailed report data export',
    'startMonth': 'Start month: ',
    'endMonth': 'End month: ',
    'Export': 'Export data',
    'PleaseSelect': 'Please select',
    'Remarks': 'Remark: ',
    'reportExportRemarks': 'Export customer sources of dealers, potential customers and order data within selected range from database to OSS, for download by dealers',
    'timeError': 'Start month cannot be greater than end month',
    'exportSuccess': 'Export data successfully',
    'notNull': 'Both start month and end month cannot be null'
  },
  'log': {
    'LogList': 'Log list',
    'Phone': 'Phone number',
    'UserPhone': "User's phone number",
    'PleaseInputUserPhone': "Please enter user's phone number",
    'ApiDesc': 'API description',
    'PleaseInputApiDesc': 'Please enter API description',
    'CreateTime': 'Creation time',
    'StartTime': 'Start time',
    'EndTime': 'End time',
    'UserName': 'Username',
    'Post': 'Role',
    'Org': 'Organization',
    'ApiType': 'Request type',
    'ApiUrl': 'Request API',
    'Result': 'Operation result',
    'Time': 'Operation time',
    'Success': 'Successful',
    'Fail': 'Failed',
    'Create': 'Create',
    'Update': 'Update',
    'Delete': 'Delete',
    'Query': 'Query'
  },
  'reportLine': {
    'Audit': 'Audit',
    'CanSeeAllData': 'Can see the entire store',
    'CanSeeSubordinate': 'Can see me and my subordinates only',
    'CanSeeOnlySelf': 'Can see me only'
  },
  'creditDevice': {
    'CreditDevice': 'Authorized device',
    'Code': 'Device code',
    'UserName': 'Username',
    'UserPhone': 'User phone',
    'PleaseInputDeviceCode': 'Please enter device code',
    'PleaseInputUserName': 'Please enter the username',
    'PleaseInputPhone': 'Please enter the phone number',
    'AppName': 'Application name',
    'Org': 'Organization',
    'Dep': 'Department',
    'CreatedAt': 'Creation time',
    'Operation': 'Operation',
    'Delete': 'Delete the device',
    'SuccessfullyDeleted': 'Delete the device successfully',
    'SelectedCreditDevices': 'Selected authorized devices',
    'AreYouSureToDelete': 'Do you confirm to delete {code} ? Data cannot be recovered once confirmed.',
    'StartAutoAudit': 'Enable automatic audit',
    'CloseAutoAudit': 'Disable automatic audit',
    'AreYouSure': 'Do you confirm to {operation} ?',
    'Successfully': 'Successfully',
    'Resolve': 'Approve',
    'Reject': 'Reject',
    'AreYouSureToAudit': 'Do you confirm to {operation} the audit request {code} ?',
    'Selected': 'Selected',
    'Audit': 'Audit',
    'Confirm': 'Confirm',
    'Batch': 'Batch'
  },
  'carCode': {
    'Car': 'Car',
    'CarCodeTitle': 'CarCodeTitle',
    'CarCodeTableList': 'CarCodeTableList',
    'AddCarCode': 'AddCarCode',
    'EditCarCode': 'EditCarCode',
    'CarCode': 'CarCode',
    'CarName': 'CarName',
    'PleaseInputCarCode': 'PleaseInputCarCode',
    'PleaseInputCarName': 'PleaseInputCarName',
    'Status': 'Status'
  },
  'job': {
    'Name': 'Post name',
    'QualificationStandard': 'Qualification standard',
    'TrainingStandard': 'Training standard',
    'Job': 'Post',
    'NeedQualificationStandard': 'Required qualification standard',
    'NeedTrainingStandard': 'Required training standard',
    'AreYouSureToDelete': 'Do you confirm to delete the post? Employees who have associated positions will be unlinked after deletion.'
  },
  'staff': {
    'StaffList': 'Employee list',
    'StaffDetail': 'Employee details',
    'StaffEdit': 'Edit staff',
    'Name': 'Name',
    'Mobile': 'Mobile',
    'QualificationSituation': 'Qualification upload situation',
    'TrainingSituation': 'Training completion situation',
    'Achievement': 'Performance',
    'Undone': 'Uncompleted',
    'Completed': 'Completed',
    'NotUploaded': 'Not uploaded',
    'Uploaded': 'Uploaded',
    'RelatedPosts': 'Associated post',
    'PleaseInputAchievement': 'Please enter performance',
    'noQualification': 'No Qualification',
    'noTraining': 'No Training'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js